import { Component, OnInit, Input } from '@angular/core';
import { Result } from '../../../objects/result';
import { EventConfig } from '../../../objects/event-config';

@Component({
  selector: 's18-thru-badge',
  templateUrl: './thru-badge.component.html',
  styleUrls: ['./thru-badge.component.scss']
})
export class ThruBadgeComponent implements OnInit {

  @Input() eventResult: Result;

  config : EventConfig;

  constructor() { }

  ngOnInit() {
    if ( this.eventResult) {
      this.config = new EventConfig(this.eventResult);
    }
  }
  
  playing() : boolean {
    return this.config.playing();
  }

  completed() : boolean {
    return this.config.completed();
  }

  notStarted() : boolean {
    return this.config.notStarted();
  }

}
